var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAtlanticCanadaCapeIslander = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#2D849F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.6504,
    y: 21.0869,
    width: 2.36503,
    height: 26.8036,
    rx: 1.18251,
    fill: "#3A3F46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1094,
    y: 21.0869,
    width: 2.36503,
    height: 22.8619,
    rx: 1.18251,
    transform: "rotate(90 39.1094 21.0869)",
    fill: "#3A3F46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1099,
    y: 26.9449,
    width: 27.0526,
    height: 14.8789,
    fill: "#67717E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1099,
    y: 33.7092,
    width: 33.8158,
    height: 14.8789,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8159,
    y: 36.4139,
    width: 5.41052,
    height: 5.41052,
    rx: 0.952838,
    fill: "#5CBCD1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8159,
    y: 28.2982,
    width: 21.6421,
    height: 4.05789,
    rx: 0.952838,
    fill: "#5CBCD1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9312,
    y: 36.4139,
    width: 5.41052,
    height: 5.41052,
    rx: 0.952838,
    fill: "#5CBCD1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0469,
    y: 36.4139,
    width: 5.41052,
    height: 5.41052,
    rx: 0.952838,
    fill: "#5CBCD1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5142,
    y: 24.2404,
    width: 29.7579,
    height: 2.70526,
    rx: 0.952838,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0576 51.2937C18.7144 52.3758 58.7523 44.5306 79.7181 38.4437C77.0128 47.1006 73.6312 48.5884 65.5154 59.4095L13.4392 60.7621C12.3571 58.5979 10.9594 56.0279 10.0576 51.2937Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3657 36.4156C62.1341 42.6163 30.5536 47.0183 7.78429 47.9201C5.75535 48.001 5.07903 49.2722 7.78429 51.3012C10.4896 53.3301 68.898 45.2141 80.3947 39.8017C83.0999 38.5281 82.3615 34.8892 78.3657 36.4156Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1152 47.9112C16.3696 50.8419 21.8252 56.4327 25.6126 55.3506C29.4 54.2685 31.6994 49.0384 32.3757 46.5585C34.4047 49.2638 35.5625 53.998 41.8441 53.998C47.3877 53.998 49.2836 46.5585 49.2836 44.5296",
    stroke: "#818A98",
    strokeWidth: 0.952838,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.91 1.91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.584 22.6636V29.7587",
    stroke: "#3A3F46",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9913 32.912C16.5813 32.912 16.2418 33.2473 16.3186 33.65C16.417 34.1665 16.6183 34.6606 16.9132 35.1019C17.3463 35.7502 17.9619 36.2554 18.6822 36.5537C19.4024 36.8521 20.195 36.9301 20.9596 36.778C21.7242 36.6259 22.4266 36.2505 22.9778 35.6993C23.5291 35.148 23.9045 34.4457 24.0566 33.681C24.2087 32.9164 24.1306 32.1239 23.8323 31.4036C23.5339 30.6834 23.0287 30.0678 22.3805 29.6346C21.9392 29.3398 21.4451 29.1385 20.9286 29.04C20.5259 28.9633 20.1906 29.3027 20.1906 29.7127C20.1906 30.1227 20.5303 30.4444 20.9217 30.5664C21.1453 30.636 21.3589 30.7377 21.5556 30.8691C21.9597 31.1391 22.2746 31.5228 22.4606 31.9718C22.6465 32.4208 22.6952 32.9148 22.6004 33.3914C22.5056 33.868 22.2716 34.3058 21.928 34.6494C21.5843 34.993 21.1466 35.227 20.6699 35.3218C20.1933 35.4166 19.6993 35.368 19.2504 35.182C18.8014 34.996 18.4177 34.6811 18.1477 34.2771C18.0162 34.0803 17.9146 33.8667 17.8449 33.6432C17.7229 33.2518 17.4013 32.912 16.9913 32.912Z",
    fill: "#3A3F46"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAtlanticCanadaCapeIslander);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AtlanticCanadaCapeIslander.56977b7f54ab3a287b84bd6ef9d6e28b.svg";